import React from "react";
import Cases from "../cases/cases";

const ReviewerMyCases: React.FC = () => {
  // Reviewers use the same Cases component as physicians
  // This allows them to upload images, get AI diagnoses, and manage their own cases
  return <Cases />;
};

export default ReviewerMyCases;
